import React from 'react'
import { MenuCountBadge } from 'components/layout/MenuCountBadge/MenuCountBadge'
import { useAppSelector } from 'shared/hooks/useReduxHooks'
import { withdrawalRequestsSelectors } from 'store/withdrawalRequests'

interface IPendingWithdrawalRequestsBadgeProps {
  children: React.ReactNode
}

export const PendingWithdrawalRequestsBadge: React.FC<IPendingWithdrawalRequestsBadgeProps> = ({
  children
}) => {
  const pendingCount = useAppSelector(withdrawalRequestsSelectors.selectPendingCount)

  return <MenuCountBadge count={pendingCount}>{children}</MenuCountBadge>
}
